export function isEmpty(object) {
  if (!object) return true;
  return !Object.keys(object).length;
}

export function isObject(value) {
  const type = typeof value;
  return value !== null && type === 'object';
}

export function isFunction(value) {
  const type = typeof value;
  return type === 'function';
}

export function forOwn(object, iteratee) {
  object = Object(object); // eslint-disable-line
  Object.keys(object).forEach(key => iteratee(object[key], key, object));
}

export function omit(obj, props) {
  props.forEach(prop => {
    delete obj[prop]; // eslint-disable-line no-param-reassign
  });

  return obj;
}

export const PLACEHOLDER = {};

export function partial(func, ...boundArgs) {
  return function partialFunction(...args) {
    let position = 0;
    const newArgs = boundArgs.map(arg => {
      if (arg === PLACEHOLDER) {
        const temp = args[position];
        position += 1;
        return temp;
      }
      return arg;
    });
    return func(...newArgs, ...args.slice(position));
  };
}

export function find(array, predicate) {
  for (let i = 0; i < array.length; i += 1) {
    if (predicate(array[i], i, array)) {
      return array[i];
    }
  }
  return undefined;
}

export function findIndex(array, predicate) {
  for (let i = 0; i < array.length; i += 1) {
    if (predicate(array[i], i, array)) {
      return i;
    }
  }
  return -1;
}

export function capitalize(string) {
  if (typeof string !== 'string' || string.length === 0) {
    return string;
  }
  // capitalize only the first letter and leave the rest unchanged
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function get(object, path, defaultValue) {
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  const result = pathArray.reduce((acc, key) => acc && acc[key], object);
  return result === undefined ? defaultValue : result;
}

export function pick(object, keys) {
  const result = {};
  keys.forEach(key => {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      result[key] = object[key];
    }
  });
  return result;
}

export function getStepperBadgeColor({ currentStep, stepIndex }) {
  if (currentStep === stepIndex) return 'blue';
  if (currentStep > stepIndex) return 'gray';
  return 'outline';
}

export function generateTempId() {
  return `temp-${Date.now()}-${Math.random()}`;
}
